import {fork} from "redux-saga/effects";

// Sagas
import {sagaProfileStart} from "./saga-profile";

export function* sagaAccountStart(api: any, action: any) {
	yield fork(sagaProfileStart, api, action);
}
